module.exports = __webpack_public_path__ + "static/media/instagram.82526960.svg";